var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fd-virtualized-list',{staticStyle:{"height":"400px"},attrs:{"min-item-size":30,"items":_vm.items,"load-more-items":_vm.loadMoreItems,"key-field":"id"},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('fd-tile',{attrs:{"transparent":"","is-button":""}},[_c('fd-tile-content',[_c('fd-tile-title',[_vm._v("#"+_vm._s(index)+" "+_vm._s(item.title))])],1)],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }